import React from 'react';
import { OptimizedImage } from '../common';
import { Brain, Shield } from 'lucide-react';

export const MissionSection: React.FC = () => {
  const features = [
    {
      icon: Brain,
      title: 'Intelligent Tools',
      description: 'AI that understands your needs and adapts to provide personalized assistance.',
    },
    {
      icon: Shield,
      title: 'Accessible Technology',
      description: 'Designed for everyone, making AI easy to use regardless of expertise.',
    },
  ];

  return (
    <section id="mission-section" className="px-4 md:px-16 py-16 md:py-24 lg:py-28 bg-[#FBF5ED]">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 gap-y-12 md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
          <div>
            <p className="mb-3 font-cairo font-semibold text-Color-Neutral-Darker md:mb-4">
              Service
            </p>
            <h2 className="mb-5 text-3xl sm:text-4xl md:text-5xl font-bold font-gabarito text-Color-Neutral-Darkest md:mb-6 leading-tight">
              At Mind<span className="text-[#C97B5A]">Clave</span>, We Serve Humanity with AI
            </h2>
            <p className="mb-6 md:mb-8 text-base sm:text-lg text-Color-Neutral-Dark font-cairo">
              Our mission is to create technology that enhances human capabilities. We
              strive to make technology useful for everyone.
            </p>
            <div className="grid grid-cols-1 gap-6 py-2 sm:grid-cols-2">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div key={index}>
                    <div className="mb-3 md:mb-4">
                      <div className="w-12 h-12 rounded-lg bg-[#E5A884] dark:bg-[#B06747] flex items-center justify-center">
                        <Icon className="w-6 h-6 text-[#B06747] dark:text-[#E5A884]" />
                      </div>
                    </div>
                    <h3 className="mb-3 text-xl font-bold font-gabarito text-Color-Neutral-Darkest md:mb-4">
                      {feature.title}
                    </h3>
                    <p className="text-Color-Neutral-Dark font-cairo">
                      {feature.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="relative h-[400px] md:h-[500px] rounded-2xl overflow-hidden">
            <OptimizedImage
              src="/images/002.serve.jpeg" 
              alt="We serve humanity with AI" 
              className="rounded-2xl"
              sizes="(max-width: 768px) 100vw, 50vw"
            />
          </div>
        </div>
      </div>
    </section>
  );
};